import { ChangeEvent, useState, FC } from "react"
import s from "../UpdateStoks.module.css"
import { useAppDispatch } from "../../../../app/hooks"
import { Modal } from "../../../../features/Modal/Modal"
import { YaCampaignType } from "../../../../app/reducers/ordersReducer"
import { StatusInfo } from "../../../UpdateStoksIcon/StatusInfo/StatusInfo"
import {
  deleteSamsonYaRecode,
  samsonYaUpdateStocks,
  uploadSamsonYaRecode,
} from "../../../../app/reducers/updateStocksSamson"
import { TipSamsonYandex } from "./tip"
import { getYaSamsonLogData } from "../../helpers"
import { LogButton } from "../../../LogButton/LogButton"
import { STATUS } from "../../../../utils/const"
import { downloadSamsonYaRecode, parseSamsonYaRecode } from "./recode"
import BaseApi from "../../../../api/api"
import { NotificationService } from "../../../../features/NotificationService/NotificationService"
import { StorageSelectControl } from "../../../StorageSelect/StorageSelectControl"
import { MARKETPLACE } from "@acc/shared"
import { Checkbox, Button } from "@radix-ui/themes"

type StocksContentProps = {
  updateStoksState: {
    lastStocksUpdated: string
    lastPricesUpdated: string
    status: STATUS
    isExistRecode: boolean
  }
  storages: YaCampaignType[]
}

const resetStocks = async (selectedStorageId: string) => {
  const response = await BaseApi.samsonYaResetStocks(selectedStorageId)
  if (response.data) {
    NotificationService.showNotification({
      message: response.data.message,
      level: (response.data.success && "success") || "error",
    })
  }
}

export const UpdateYaStocksTab: FC<StocksContentProps> = ({
  updateStoksState,
  storages,
}) => {
  const dispatch = useAppDispatch()
  const [selectedStorageId, setSelectedStorages] = useState("")
  const [isOpenModalUpdatePrices, setOpenModalUpdatePrices] = useState(false)
  const [isOpenModalResetStocks, setOpenModalResetStocks] = useState(false)
  const [updatePrices, setUpdatePrices] = useState(false)
  const [updateStocks, setUpdateStocks] = useState(false)
  const { lastStocksUpdated, lastPricesUpdated, status, isExistRecode } =
    updateStoksState || {}

  const handleUpdate = () => {
    if ((updatePrices || updateStocks) && isExistRecode && selectedStorageId) {
      setOpenModalUpdatePrices(true)
    }
  }

  const onResetClick = () => {
    if (isExistRecode && selectedStorageId) {
      setOpenModalResetStocks(true)
    }
  }

  return (
    <div>
      {lastPricesUpdated && (
        <h6>
          Последнее обновление цен:{" "}
          {new Date(lastPricesUpdated).toLocaleString()}
        </h6>
      )}
      {lastStocksUpdated && (
        <h6>
          Последнее обновление остатков:{" "}
          {new Date(lastStocksUpdated).toLocaleString()}
        </h6>
      )}
      {status && (
        <h6>
          Статус: <StatusInfo status={status} />
        </h6>
      )}

      <div className={s.uploadFileWrap}>
        {isExistRecode ? (
          <div className={s.uploadedWrap}>
            <Button
              onClick={() => {
                dispatch(deleteSamsonYaRecode())
              }}
            >
              Удалить файл перекодировки
            </Button>
            <Button onClick={downloadSamsonYaRecode}>
              Скачать перекодировку
            </Button>
          </div>
        ) : (
          <div>
            <Button asChild>
              <label htmlFor={s.ktrnFileInp}>
                Загрузить файл перекодировки
                <input
                  style={{ display: "none" }}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    const file = e.target.files?.[0]
                    if (file) {
                      parseSamsonYaRecode(file).then((recode) => {
                        dispatch(uploadSamsonYaRecode(recode))
                      })
                    }
                  }}
                  type="file"
                  accept=".xlsx"
                  id={s.ktrnFileInp}
                />
              </label>
            </Button>
          </div>
        )}
        <TipSamsonYandex />
      </div>

      <StorageSelectControl
        label="Склад для обновления"
        value={selectedStorageId}
        onChange={(value) => {
          setSelectedStorages(value)
        }}
        controlKey="storages-select"
        marketplace={MARKETPLACE.YANDEX}
      />
      <div className={s.checkboxContainer}>
        <label>
          <Checkbox
            checked={updatePrices}
            onCheckedChange={(value) => setUpdatePrices(value === true)}
          />
          Обновить цены
        </label>
        <label>
          <Checkbox
            checked={updateStocks}
            onCheckedChange={(value) => setUpdateStocks(value === true)}
          />
          Обновить остатки
        </label>
      </div>
      <Button
        className={s.updateButton}
        disabled={
          !isExistRecode ||
          !selectedStorageId ||
          (!updatePrices && !updateStocks)
        }
        onClick={handleUpdate}
      >
        Обновить
      </Button>
      <Button
        className={s.updateButton}
        disabled={!isExistRecode || !selectedStorageId}
        onClick={onResetClick}
      >
        Сбросить остатки на складе
      </Button>
      <LogButton getData={getYaSamsonLogData} />

      <Modal
        isOpen={isOpenModalUpdatePrices}
        header="Подтвердите действие. Обновление на Самсон ОПТ"
        content={`Обновить ${updatePrices ? "цены" : ""} ${
          updatePrices && updateStocks ? "и" : ""
        } ${updateStocks ? "остатки" : ""} для склада ${
          storages.find((el) => el.id === +selectedStorageId)?.domain
        }`}
        onClose={() => setOpenModalUpdatePrices(false)}
        onOk={() => {
          selectedStorageId &&
            dispatch(
              samsonYaUpdateStocks({
                selectedStorageId,
                updatePrices,
                updateStocks,
              }),
            )
          setOpenModalUpdatePrices(false)
        }}
      />
      <Modal
        isOpen={isOpenModalResetStocks}
        header="Подтвердите действие. Сбросить остатки на Самсон ОПТ"
        content={`Сбросить остатки для склада ${
          storages.find((el) => el.id === +selectedStorageId)?.domain
        }`}
        onClose={() => setOpenModalResetStocks(false)}
        onOk={() => {
          selectedStorageId && resetStocks(selectedStorageId)
          setOpenModalResetStocks(false)
        }}
      />
    </div>
  )
}
